import { render } from "./PremiumReconciliation.vue?vue&type=template&id=17e86207&scoped=true"
import script from "./PremiumReconciliation.vue?vue&type=script&lang=js"
export * from "./PremiumReconciliation.vue?vue&type=script&lang=js"

import "./PremiumReconciliation.vue?vue&type=style&index=0&id=17e86207&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e86207"]])

export default __exports__